import React, { Component } from 'react';
import firebase from './../Firestore'
import { Link } from 'react-router-dom';

import config from 'react-global-configuration';

import CategoriaNombre from './CategoriaNombre'
import NavBar from './NavBar'


class AdicionalShow extends Component {

  constructor(props) {
    super(props);
    this.unsubscribe = null;
    this.state = {
      adicional: {},
      key: ''
    };
  }

  async componentDidMount() {
    const ref = firebase.firestore().collection('adicionales').doc(this.props.match.params.id);
    this.unsubscribe = await ref.get().then((doc) => {
      if (doc.exists) {
        this.setState({
          adicional: doc.data(),
          key: doc.id
        });
      } else {
        console.log("No such document!");
      }
    });

  }


  delete(id){
    firebase.firestore().collection('adicionales').doc(id).delete().then(() => {
      console.log("Document successfully deleted!");
      this.props.history.push("/admin/adicional/lista")
    }).catch((error) => {
      console.error("Error removing document: ", error);
    });
  }

  render() {

    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              {this.state.adicional.nombre}
            </h3>
          </div>
          <div className="panel-body">
            <dl>
              <dt>Adicional en la Categoria:</dt>
              <dd><CategoriaNombre categoriaID={this.state.adicional.categoriaID} /></dd>


              <dt>En Stock?:</dt>
              <dd><span className="mr-2"><small>{this.state.adicional.enStock ? "SI" : "NO"}</small></span></dd>

                <dt>Precio:</dt>
                <dd><span className="text-success h6 mr-2">${this.state.adicional.precio}</span></dd>





            </dl>
            <Link to={`/admin/adicional/edit/${this.state.key}`} className="btn btn-success">Editar</Link>&nbsp;
            <button onClick={this.delete.bind(this, this.state.key)} className="btn btn-danger">Delete</button>
          </div>
        </div>
      </div>
    );
  }
}

export default AdicionalShow;
